export default {
  path: 'pension',
  name: 'pension',
  meta: {
    requiresPermission: true,
    app: 'TOOLKIT',
    nav: true,
  },
  component: () => import(
      /* webpackChunkName: "pension" */ '@/app/views/toolkit/pension/Pension.vue'
    ),
  children: [
    {
      path: 'establishment',
      meta: {
        requiresPermission: true,
        app: 'TOOLKIT',
        nav: true,
      },
      component: () => import(
          /* webpackChunkName: "pension" */ '@/app/views/toolkit/pension/establishment/PensionEstablishment.vue'
        ),
      children: [
        {
          path: '',
          name: 'pension-establishment-dashboard',
          meta: {
            requiresPermission: true,
            requiresSubscription: true,
            app: 'TOOLKIT',
            nav: true,
          },
          component: () => import(
              /* webpackChunkName: "establishment-dashboard" */ '@/app/views/toolkit/pension/establishment/modules/Dashboard.vue'
            ),
        },
        {
          path: 'welcome',
          name: 'pension-establishment-welcome',
          meta: {
            requiresPermission: true,
            requiresSubscription: true,
            app: 'TOOLKIT',
            nav: true,
          },
          component: () => import(
              /* webpackChunkName: "establishment-welcome" */ '@/app/views/toolkit/pension/establishment/modules/Welcome.vue'
            ),
        },
        {
          path: 'item',
          name: 'pension-establishment-item',
          meta: {
            requiresPermission: true,
            requiresStore: true,
            app: 'TOOLKIT',
            nav: true,
          },
          component: () => import(
              /* webpackChunkName: "establishment-item" */ '@/app/views/toolkit/pension/establishment/modules/Item.vue'
            ),
        },
      ],
    },
    {
      path: 'payment-instruction',
      meta: {
        requiresPermission: true,
        app: 'TOOLKIT',
        nav: true,
      },
      component: () => import(
          /* webpackChunkName: "pension-payment-instruction" */ '@/app/views/toolkit/pension/payment-instruction/PensionPaymentInstruction.vue'
        ),
      children: [
        {
          path: '',
          name: 'pension-payment-instruction-dashboard',
          meta: {
            requiresPermission: true,
            requiresSubscription: true,
            app: 'TOOLKIT',
            nav: true,
          },
          component: () => import(
              /* webpackChunkName: "payment-instruction-dashboard" */ '@/app/views/toolkit/pension/payment-instruction/modules/Dashboard.vue'
            ),
        },
        {
          path: 'welcome',
          name: 'pension-payment-instruction-welcome',
          meta: {
            requiresPermission: true,
            requiresSubscription: true,
            app: 'TOOLKIT',
            nav: true,
          },
          component: () => import(
              /* webpackChunkName: "payment-instruction-welcome" */ '@/app/views/toolkit/pension/payment-instruction/modules/Welcome.vue'
            ),
        },
        {
          path: 'item',
          name: 'pension-payment-instruction-item',
          meta: {
            requiresPermission: true,
            requiresStore: true,
            app: 'TOOLKIT',
            nav: true,
          },
          component: () => import(
              /* webpackChunkName: "payment-instruction-item" */ '@/app/views/toolkit/pension/payment-instruction/modules/Item.vue'
            ),
        },
      ],
    },
  ],
};
